import React from 'react';
import {getColumns} from '../helpers/form';
import {NPC_LANGUAGES} from './npcConstants';

class LanguageList extends React.Component {

    renderColumn = (column) => {
        return column.map(type => <div className="form-group col-4" key={`languages-${type.key}`}>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" name="language" value={type.key} id={`languages${type.key}Check`} checked={this.props.hasLanguage(type.key)} onChange={this.props.update} />
                <label className="form-check-label" htmlFor={`languages${type.key}Check`}>
                    {type.name}
                </label>
            </div>
        </div>);
    };

    render() {
        const columns = getColumns(NPC_LANGUAGES, 2);

        return <div className="row">
            {columns.map((column, index) => {
                return <div className="col-6" key={`condition-col-${index}`}>
                    {this.renderColumn(column)}
                </div>;
            })}
        </div>;
    }
}

export default LanguageList;